(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dw-header-bars"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dw-header-bars')) {
    customElements.define('dw-header-bars', class extends HTMLElement {
      connectedCallback() {
        this.stopTimer();
        const sale = this.querySelector('[data-sale]');
        const timer = this.querySelector('[data-timer]');
        if (!sale || !timer) return;
        const hours = timer.querySelector('[data-hours]');
        const minutes = timer.querySelector('[data-minutes]');
        const seconds = timer.querySelector('[data-seconds]');
        const tick = () => {
          const now = Date.now();
          // Date uses the visitor's device timezone. Setting hour 24 finds
          // their next local midnight, including daylight saving changes.
          // Recalculate on every tick so midnight and browser resumes reset
          // automatically, without a setting, saved timestamp or page reload.
          const end = new Date(now);
          end.setHours(24, 0, 0, 0);
          const remaining = Math.max(0, Math.ceil((end.getTime() - now) / 1000));
          sale.hidden = false;
          timer.hidden = false;
          const h = Math.floor(remaining / 3600);
          const m = Math.floor(remaining % 3600 / 60);
          const s = remaining % 60;
          hours.textContent = String(h).padStart(2, '0');
          minutes.textContent = String(m).padStart(2, '0');
          seconds.textContent = String(s).padStart(2, '0');
          timer.setAttribute('aria-label', `Sale ends in ${h} hours, ${m} minutes and ${s} seconds`);
        };
        tick();
        this.interval = window.setInterval(tick, 1000);
      }
      disconnectedCallback() { this.stopTimer(); }
      stopTimer() {
        if (this.interval !== undefined) window.clearInterval(this.interval);
        this.interval = undefined;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
